module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0019_17_D18_3.67b4433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0019_17_D18_3.jpg
// module id = dZcD
// module chunks = 0